// use client: activeTab state drives the product tab switcher below
'use client'

import '@/styles/bootstrap-icons.css'
import '@/components/radio/radio.css'
import './personal.css'

import { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Others from '@/assets/images/hero-images/Banner_Others.webp'
import BG from '@/assets/images/hero-images/BG.webp'
import ReferralForm from '@/components/forms/ReferralForm'
import { Jumbotron } from '@/sections'
import LetsConnect from '@/sections/ComingSoon/LetsConnect'
import { formatTitleWithItalic, preserveHyphenatedWords } from '@/utils'

function Affluent({ initialData }) {
  // Content comes from the build-time snapshot only. A Strapi publish rebuilds
  // and redeploys the site, so there is nothing to revalidate on mount.
  // See tests/no-client-cms-fetch.spec.ts.
  const objData = initialData
  const [activeTab, setActiveTab] = useState(initialData?.TabsData?.[0]?.label)

  const jumbotronTitle = `<span className="jumbotron-subtitle-2">Affluent</span> Banking<br/><span className="jumbotron-subtitle-2">Diamond Affluent</span> Banking`
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText={''}
          title={objData?.jumbotron_title || jumbotronTitle}
          backgroundImage={Others.src}
          uniqueBg={BG.src}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: 'center' }}>
          <div className="col-xl-4">
            <h2>
              Bespoke Islamic
              <br />
              Affluent Banking
            </h2>
          </div>
          <div className="col-xl-8">
            <p>{objData?.about || ''}</p>
          </div>
        </div>

        {/* Value Section */}
        <div className="row" style={{ justifyContent: 'center', marginTop: 60 }}>
          <div className="col-xl-4">
            <h2>
              Premier advantages
              <br />
              and advisory
            </h2>
          </div>
          <div className="col-xl-8">
            <p>{objData?.value_propositions || ''}</p>
          </div>
        </div>

        {/* Benefits Section */}
        <div>
          {objData?.GeneralData &&
            objData?.GeneralData?.map((item, index) => (
              <div className="gradient-feature-box" key={item.title}>
                <div className="title-box">
                  <div>
                    <img src={item.image} alt="Icon" style={{ width: '50px', height: '50px' }} />
                  </div>
                  <h3>{formatTitleWithItalic(item.title)}</h3>
                </div>
                {index === 0 ? (
                  preserveHyphenatedWords(item.description)
                ) : (
                  <div
                    style={{ width: '66%' }}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></div>
                )}
              </div>
            ))}
        </div>
      </section>

      {objData?.TabsData && (
        <section className="section about container">
          {/* Tabs */}
          <div
            className="pill-radio-container"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              backgroundColor: '#F2F4F7',
              alignItems: 'center',
              margin: '0 auto',
              width: 'fit-content',
              marginBottom: '40px'
            }}
          >
            {objData?.TabsData &&
              objData?.TabsData.map(item => {
                return (
                  <div
                    key={item.label}
                    onClick={() => {
                      setActiveTab(item.label)
                    }}
                    className={`item cursor-pointer ${activeTab === item.label ? `active` : ``}`}
                    style={{
                      padding: '10px 20px',
                      background:
                        activeTab === item.label
                          ? 'linear-gradient(90deg, #070097, #211AFB)'
                          : 'transparent',
                      color: activeTab === item.label ? '#fff' : '#000'
                    }}
                  >
                    {item.label}
                  </div>
                )
              })}
          </div>
          {/* Content */}
          <div className="row justify-content-center">
            <div className="col-xl-4 mb-3">
              <h2 className="qualify-heading">
                {objData?.TabsData[activeTab === objData?.TabsData[0].label ? 0 : 1].title}
              </h2>
            </div>
            <div className="col-xl-8">
              <div className="p-3 rounded">
                {activeTab === objData?.TabsData[0].label &&
                  preserveHyphenatedWords(objData?.TabsData[0].content)}
                {activeTab === objData?.TabsData[1].label &&
                  preserveHyphenatedWords(objData?.TabsData[1].content)}
              </div>
            </div>
          </div>
        </section>
      )}

      <section id="referral-form-section" className="my-5 py-sm-5">
        <Container className="py-5">
          <Row>
            <Col>
              <ReferralForm />
            </Col>
          </Row>
        </Container>
      </section>

      <LetsConnect title="Let's arrange a conversation at your convenience" />
    </div>
  )
}

export default Affluent
